export function successConf(title) {
  return {
    title,
    variant: "success",
    toaster: "b-toaster-bottom-center",
    solid: true
  };
}

export function errorConf(title) {
  return {
    title,
    variant: "danger",
    toaster: "b-toaster-bottom-center",
    solid: true
  };
}
